// eslint-disable-next-line eag/no-external-date-time-format-functions -- Intended to use here
import {format, formatDistanceToNowStrict} from 'date-fns';
import {match} from 'ts-pattern';

import {curry} from 'ramda';

import {LocaleConfig} from '../../../types/LocaleConfig';
import {LocaleDateTimeFormat} from '../../../types/LocaleDateTimeFormat';
import {convertStringLocaleToDateFns} from '../../../utils/convertStringLocaleToDateFns';

function uncurriedFormatDateTime(
  localeConfig: LocaleConfig,
  language: string,
  dateTimeFormat: LocaleDateTimeFormat,
  value: Date
) {
  const dateFnsLocale = localeConfig.dateFnsLocale ?? convertStringLocaleToDateFns(language);

  return match(dateTimeFormat)
    .with('dateRelative', () =>
      formatDistanceToNowStrict(value, {
        addSuffix: true,
        locale: dateFnsLocale,
      })
    )
    .otherwise((formatKey) =>
      format(value, localeConfig.dateTimeFormat[formatKey], {
        locale: dateFnsLocale,
      })
    );
}

export const formatDateTime = curry(uncurriedFormatDateTime);
